var map = {
	"./m1.png": 3807,
	"./m2.png": 8692,
	"./m3.png": 9821,
	"./m4.png": 8098,
	"./m5.png": 8603,
	"./m6.png": 4784,
	"./m7.png": 1033,
	"./m8.png": 1646,
	"./m9.png": 1143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7429;